export default __webpack_public_path__ + "static/media/deck.fc908e50.pdf";